export default {"src":"/_next/static/media/home-icon.cf80a02d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};